import { useSelector } from 'modules/react-redux';
import { useMemo } from 'react';

import { getQBooksLineItemsV2 } from '../../../../selectors/qbooks';
import { useRequest } from './useRequest';

export const useLineItems = () => {
    const request = useRequest();

    const lineItemsSelector = useMemo(() => getQBooksLineItemsV2(request), [request]);

    return useSelector(lineItemsSelector);
};
